import React, { useRef, useEffect } from 'react';

function LLMCodedField({ html }) {
    const ref = useRef(null);

    //this adds the scripts in programmatically so they aren't blocked by the browser
    useEffect(() => {
        if (!ref.current) return;
        (async () => {
            for (const old of [...ref.current.querySelectorAll('script')]) {
                const s = document.createElement('script');
                for (const a of old.attributes) s.setAttribute(a.name, a.value);
                s.textContent = old.textContent;
                const loaded = s.src ? new Promise(ok => { s.onload = s.onerror = ok; }) : null;
                old.replaceWith(s);
                if (loaded) await loaded;
            }
        })();
    }, [html]);

    return <div ref={ref} dangerouslySetInnerHTML={{ __html: html }} />;
}

export default LLMCodedField;
